import classNames from 'classnames'
import { Dispatch, SetStateAction, useState } from 'react'
import Modal from '@/stories/components/Common/Modal'

function DeliveryFilters({
  selected,
  setSelected,
  mode,
}: {
  selected: string
  setSelected: Dispatch<SetStateAction<string>>
  mode: 'sips' | 'cnc' | 'intraday' | 'pledge' | 'GTT'
}) {
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'all',
            'border-brand-grey-light text-brand-grey-light': selected !== 'all',
          },
        )}
        onClick={() => setSelected('all')}
      >
        All Orders
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'completed',
            'border-brand-grey-light text-brand-grey-light':
              selected !== 'completed',
          },
        )}
        onClick={() => setSelected('completed')}
      >
        Completed Orders
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'failed',
            'border-brand-grey-light text-brand-grey-light':
              selected !== 'failed',
          },
        )}
        onClick={() => setSelected('failed')}
      >
        Failed Orders
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'pending',
            'border-brand-grey-light text-brand-grey-light':
              selected !== 'pending',
          },
        )}
        onClick={() => setSelected('pending')}
      >
        Pending Orders
      </button>
      {mode !== 'pledge' && (
        <button
          className={classNames(
            'border-1 rounded-full px-2 py-1 text-sm transition-colors',
            {
              'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
                selected === 'cancelled',
              'border-brand-grey-light text-brand-grey-light':
                selected !== 'cancelled',
            },
          )}
          onClick={() => setSelected('cancelled')}
        >
          Cancelled Orders
        </button>
      )}
    </div>
  )
}

function SIPFilters({
  selected,
  setSelected,
}: {
  selected: string
  setSelected: Dispatch<SetStateAction<string>>
}) {
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'all',
            'border-brand-grey-light text-brand-grey-light': selected !== 'all',
          },
        )}
        onClick={() => setSelected('all')}
      >
        All SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'registered',
            'border-brand-grey-light text-brand-grey-light':
              selected !== 'registered',
          },
        )}
        onClick={() => setSelected('registered')}
      >
        Registered SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'paused',
            'border-brand-grey-light text-brand-grey-light':
              selected !== 'paused',
          },
        )}
        onClick={() => setSelected('paused')}
      >
        Paused SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'failed',
            'border-brand-grey-light text-brand-grey-light':
              selected !== 'failed',
          },
        )}
        onClick={() => setSelected('failed')}
      >
        Failed SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'pending',
            'border-brand-grey-light text-brand-grey-light':
              selected !== 'pending',
          },
        )}
        onClick={() => setSelected('pending')}
      >
        Pending SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-brand-blue-azureRadiance text-brand-blue-azureRadiance':
              selected === 'cancelled',
            'border-brand-grey-light text-brand-grey-light':
              selected !== 'cancelled',
          },
        )}
        onClick={() => setSelected('cancelled')}
      >
        Cancelled SIPs
      </button>
    </div>
  )
}

export default function INStocksTransactionsFilterModal({
  showModal,
  onClose,
  mode,
  setFilter,
  filter,
}: {
  showModal: boolean
  onClose: () => void
  mode: 'sips' | 'cnc' | 'intraday' | 'pledge' | 'GTT'
  setFilter: Dispatch<
    SetStateAction<{
      type: string | null
    }>
  >
  filter: {
    type: string | null
  }
}) {
  const [selected, setSelected] = useState(filter.type ?? '')
  return (
    <Modal
      showModal={showModal}
      onClose={() => onClose()}
      bodyClassName="max-w-lg lg:max-w-1/3"
      childrenClassName="!p-0"
    >
      <div className="flex flex-col justify-center ">
        <p className="text-brand-grey-dark mb-3 px-3 pt-3 text-left text-lg font-medium">
          Filters
        </p>
        <div className="px-3">
          <p className="text-brand-grey-base text-sm">By Type</p>
          {(mode === 'cnc' ||
            mode === 'intraday' ||
            mode === 'pledge' ||
            mode === 'GTT') && (
            <DeliveryFilters
              setSelected={setSelected}
              selected={selected}
              mode={mode}
            />
          )}
          {mode === 'sips' && (
            <SIPFilters setSelected={setSelected} selected={selected} />
          )}
        </div>
        <div className=" shadow-two mt-5 flex items-center justify-between rounded-b-xl px-20 py-5">
          <span
            className="text-brand-blue-azureRadiance w-1/2 cursor-pointer text-center text-base"
            onClick={() => {
              setFilter({ type: 'all' })
              void onClose()
            }}
          >
            Clear All
          </span>
          <button
            className="bg-brand-green-dark text-brand-white shadow-one  w-1/2 rounded-full py-2 text-center"
            onClick={() => {
              setFilter({ type: selected })
              void onClose()
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </Modal>
  )
}
